import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { formatAsGermanDate } from '~/functions/helpers';
import { useGetQuestionnairesForVenturesAndLabelQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'EsgQuestionnaires',
  props: {
    ventureIds: null,
    label: null,
    showPeriodColumns: {
      type: Boolean
    }
  },
  emits: ['select'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var displayPeriodColumns = computed(function () {
      return props.showPeriodColumns !== false;
    });
    var inputs = computed(function () {
      return {
        ventureIds: props.ventureIds,
        label: props.label || 'ESG'
      };
    });
    var _useGetQuestionnaires = useGetQuestionnairesForVenturesAndLabelQuery(inputs),
      result = _useGetQuestionnaires.result,
      loading = _useGetQuestionnaires.loading,
      refetch = _useGetQuestionnaires.refetch;
    expose({
      refetch: refetch
    });
    var items = computed(function () {
      var _result$value$getQues, _result$value;
      return (_result$value$getQues = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getQuestionnairesForVenturesAndLabel.map(function (q) {
        var _q$period, _q$period2, _q$period3;
        return {
          id: q.id,
          ventureId: q.venture.id,
          name: q.venture.name,
          periodStart: (_q$period = q.period) === null || _q$period === void 0 ? void 0 : _q$period.startDate,
          periodEnd: (_q$period2 = q.period) === null || _q$period2 === void 0 ? void 0 : _q$period2.endDate,
          userDefined: (_q$period3 = q.period) === null || _q$period3 === void 0 ? void 0 : _q$period3.userDefined,
          updatedAt: q.updatedAt,
          isEditable: q.isEditable ? 'Yes' : 'No'
        };
      })) !== null && _result$value$getQues !== void 0 ? _result$value$getQues : [];
    });
    var headers = computed(function () {
      var baseHeaders = [{
        text: proxy.$i18n.t('name'),
        value: 'name',
        align: 'center'
      }];
      var periodHeaders = displayPeriodColumns.value ? [{
        text: proxy.$i18n.t('periodStart'),
        value: 'periodStart',
        align: 'center'
      }, {
        text: proxy.$i18n.t('periodEnd'),
        value: 'periodEnd',
        align: 'center'
      }, {
        text: proxy.$i18n.t('customReferencePeriod'),
        value: 'userDefined',
        align: 'center'
      }] : [];
      return [].concat(baseHeaders, periodHeaders, [{
        text: proxy.$i18n.t('isEditable'),
        value: 'isEditable',
        align: 'center'
      }, {
        text: proxy.$i18n.t('updatedAt'),
        value: 'updatedAt',
        align: 'center'
      }]);
    });
    var filters = ref({
      isEditable: []
    });
    var filteredItems = computed(function () {
      var list = items.value;
      if (filters.value.isEditable.length) {
        list = list.filter(function (i) {
          return filters.value.isEditable.includes(i.isEditable);
        });
      }
      return list;
    });
    var selectedIds = ref([]);
    watch(selectedIds, function (ids) {
      emit('select', ids);
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      proxy: proxy,
      displayPeriodColumns: displayPeriodColumns,
      inputs: inputs,
      result: result,
      loading: loading,
      refetch: refetch,
      items: items,
      headers: headers,
      filters: filters,
      filteredItems: filteredItems,
      selectedIds: selectedIds,
      formatAsGermanDate: formatAsGermanDate
    };
  }
});